import { UseMutationOptions, useQueryClient, useMutation } from "@tanstack/react-query";
import { unauthedMutationFunction } from "./apiFunctions/mutationFunctions/unauthedMutationFunction";
import { CsError } from "./CsError";
type ApiQueryKey = readonly [string]
type ApiMutationOptions<TResponse, TRequestBody = undefined> = Omit<UseMutationOptions<TResponse, CsError, TRequestBody>, 'mutationFn'>

export function useUnauthedApiMutation<TResponse, TRequestBody = undefined>(
  path: string,
  method: 'POST' | 'PUT' | 'DELETE',
  mutationOptions?: ApiMutationOptions<TResponse, TRequestBody>
) {
  const mutationKey = [path] as ApiQueryKey
  const queryClient = useQueryClient()

  return useMutation<TResponse, CsError, TRequestBody>({
    onSuccess: (data) => {
      // Cache the result so it can be reused
      queryClient.setQueryData(mutationKey, data);
    },
    ...mutationOptions,
    mutationKey,
    mutationFn: async (body: TRequestBody) => {
      return unauthedMutationFunction<TResponse, TRequestBody>(body, method, path)
    }
  });
}
